import type { AudioBriefingErrorType } from '../types/audioBriefingErrorType';
import { AudioBriefingError } from '../types/audioBriefingErrorType';

export const shouldMarkErrorAsHandled = (error: AudioBriefingErrorType | undefined): boolean => {
	if (error === AudioBriefingError.CONTENT_TOO_SHORT) {
		return true;
	}

	return false;
};
